<template>
<div>
    <Spinner v-if="loading" class="mt-5">{{ loadingMessage}}</Spinner>

    <div v-else class="row verifyrow text-center">
        <div v-if="view !='otp'">
            <p class="mb-3" style="margin-top:70px;">You will be redirected to your card's issuer's verification page to authorize this payment.</p>
        </div>
        <div v-else>
            <p class="enterotp ">Please enter your 4-digit card pin to authorize this payment</p>

            <span class="invalid-feedback" :style="(errors.card_pin) ? 'display : inline' : ''">{{errors.card_pin}}</span>

            <div class="verificationform" style="margin:0px">
                <input type="password" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" v-model="card_pin1" ref="card_pin_input1" id="card_pin_input1" required autofocus @focus="isFocus = true" @blur="isFocus = false" :style="{ border: (isFocus ? isFocusColor : '')  }" style="margin-right: 5px !important;" />
                <input type="password" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" v-model="card_pin2" ref="card_pin_input2" id="card_pin_input2" required @focus="isFocus2 = true" @blur="isFocus2 = false" :style="{ border: (isFocus2 ? isFocus2Color : '') , borderColorRight : (isFocus2 ? 'solid' + appColor : '')  }" style="margin-right: 5px !important;" />
                <input type="password" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" v-model="card_pin3" ref="card_pin_input3" id="card_pin_input3" required @focus="isFocus3 = true" @blur="isFocus3 = false" :style="{ border: (isFocus3 ? isFocus3Color : '')  }" style="margin-right: 5px !important;" />
                <input type="password" maxLength="1" size="1" min="0" max="9" pattern="[0-9]{1}" autocomplete="off" v-model="card_pin4" ref="card_pin_input4" id="card_pin_input4" required @focus="isFocus4 = true" @blur="isFocus4 = false" :style="{ border: (isFocus4 ? isFocus4Color : '')  }" style="margin-right: 5px !important;" />
            </div>

            <slot name="amount" />

            <div class="row m-0">
                <div class="col-12 px-0 mb-0">
                    <div class="form-group mb-0 text-center">
                        <a href="javascript:void(0)" class="text-tiny" @click.prevent="goBack"> Change card</a>
                    </div>
                    <div class="form-group text-center mb-0 mt-3">
                        <button type="button" class=" viabutton submit" :style="button_color" @click.prevent="validateCardPin" ref="btnActionPay" id="btnActionPay"> Make Payment </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue';

export default {
    name: 'Pin',
    props: ['appColor', 'client_info', 'button_color'],
    components: {
        Spinner
    },
    watch: {
        isFocus(newVal) {
            if (newVal)
                this.isFocusColor = 'solid 1px ' + this.appColor;
        },
        isFocus2(newVal) {
            if (newVal)
                this.isFocus2Color = 'solid 1px ' + this.appColor;
        },
        isFocus3(newVal) {
            if (newVal)
                this.isFocus3Color = 'solid 1px ' + this.appColor;
        },
        isFocus4(newVal) {
            if (newVal)
                this.isFocus4Color = 'solid 1px ' + this.appColor;
        },
        card_pin1: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input2.focus()
                }
            },
            deep: true
        },
        card_pin2: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input3.focus()
                }
            },
            deep: true
        },
        card_pin3: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input4.focus()
                }
            },
            deep: true
        },
        card_pin4: {
            handler: function (val, old) {
                val = val.trim()
                if (!isNaN(val) && val.length > 0) {
                    this.$refs.card_pin_input4.blur()
                }
            },
            deep: true
        }
    },
    created() {
        this.amount = this.$store.state.payload.transaction.amount / 100
    },
    mounted() {
        this.isFocusColor = 'solid 1px ' + this.appColor;
        if(this.$refs.card_pin_input1)
            this.$refs.card_pin_input1.focus();
        this.provider = this.$store.state.provider
    },
    data() {
        return {
            card_pin: '',
            card_pin1: '',
            card_pin2: '',
            card_pin3: '',
            card_pin4: '',
            isFocus: true,
            isFocus2: false,
            isFocus3: false,
            isFocus4: false,
            isFocusColor: '',
            isFocus2Color: '',
            isFocus3Color: '',
            isFocus4Color: '',
            loadingMessage: 'Processing Transaction',
            // disabled: true,
            provider: null,
            amount: 0,
            loading: false,
            view: 'otp',
            initial_redirect_data: null,
            errors: {
                card_pin: false,
            }
        }
    },
    methods: {
        goBack() {
            this.$parent.changeComponent('CardPayment');
            this.loading = false;
        },

        validateCardPin() {
            this.card_pin = `${this.card_pin1}${this.card_pin2}${this.card_pin3}${this.card_pin4}`

            if (this.card_pin.length < 4) {
                this.errors.card_pin = 'Pin must be 4 digits';
                return;
            }

            this.validate();
        },

        setupredirect(url) {
            let
                isLocalhost = window.location.hostname === 'localhost',
                response = {
                    'status': 'redirect',
                    'data': {
                        'transaction': this.$store.state.payload.transaction,
                        'redirectUrl': isLocalhost ?
                            'http://redirect.md/' : this.current_option.custom_ui_url,
                        "callback_url": isLocalhost ?
                            'http://redirect.md/' : this.current_option.extras.callback_url,
                        'chargeUrl': url,
                        'sourceUrl': isLocalhost ?
                            'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                        'provider': this.provider,
                    }
                }
            this.$parent.componentId = "";
            window.parent.postMessage(JSON.stringify(response), '*');
            this.$parent.in_view = '';
        },

        handleRedirect(provider_response, message) {
            if (provider_response != null && Object.keys(provider_response).includes('meta') && provider_response.meta && Object.keys(provider_response.meta).includes('redirect_url')) {
                this.view = '3dsecure'
                this.loadingMessage = 'Redirecting.. please wait'
                setTimeout(() => {
                    this.loading = true;
                    setTimeout(() => {
                        this.setupredirect(provider_response.meta.redirect_url);
                    }, 2000);
                }, 4000)

                return;
            }

            this.$parent.changeComponent('OTP', {
                message,
            });
        },

        validate() {
            let payload = this.$store.state.payload;
            payload.auth = {
                type: 'card',
                secure: `${this.$store.state.card_cc};${this.$store.state.card_cvv};${this.$store.state.card_exp};${this.card_pin}`,
                // auth_provider: 'Quickteller'
            }

            if (Object.keys(this.provider).includes('provider') && this.provider.provider != null) {
                payload.auth.auth_provider = this.provider.provider;
            }

            payload.transaction.transaction_ref = this.$store.state.transRef
            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            if (Object.keys(payload.transaction).includes('transaction_desc'))
                payload.transaction.transaction_desc = `${payload.transaction.transaction_ref}_${payload.transaction.transaction_desc}`;

            let data2 = {
                endpoint: 'transact',
                api_key: this.$store.state.api_key,
                payload
            };

            delete data2.payload.api_key;
            delete data2.payload.hasTLSFallback
            delete data2.payload.mode
            let dataPayload = this.$generateToken(data2);

            this.submitDetails(dataPayload)
        },
        submitDetails(dataPayload) {

            this.loading = true;

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data: dataPayload
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }).then(({
                    data
                }) => {

                    this.trx_otp = '';

                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    this.loading = false;

                    if (status == "successful") {
                        return  this.$parent.changeComponent('Status', {
                            reference: payload.transRef,
                            type: 'Successful',
                            data: responseData,
                            message
                        });

                    } else if (['pendingvalidation','waitingforotp'].includes(status)) {
                        return this.handleRedirect(responseData.provider_response, message);
                    } 

                    window.failedFromStartMessage = message || "An error occured from the main server, please try again or contact the webmaster hussien@onepipe.io."
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');

                })
                .catch(error => {
                    window.raw = JSON.stringify(error);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = error;
                    this.$router.push('/v2/mtn/warning');
                })
        }
    }

}
</script>
